import { render, staticRenderFns } from "./IllnessPeriodModal.vue?vue&type=template&id=173d9d63"
import script from "./IllnessPeriodModal.vue?vue&type=script&lang=js"
export * from "./IllnessPeriodModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports